import {Component, Input, ViewChild} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {ApproveDebtorUploadRowService} from './approveDebtorUploadRow.service';

@Component({
  selector: 'approveDebtorUploadRow',
  templateUrl: './approveDebtorUploadRow.component.html',
  providers: [ApproveDebtorUploadRowService],
})
export class ApproveDebtorUploadRowComponent extends BaseGridNoCookieComponent<ApproveDebtorUploadRowService> {
  @ViewChild('approveDebtorUploadRow')
  public approveDebtorUploadRow: ModalDirective;

  /*
   *  Modal handling
   */

  @Input() id;

  public showChildModal(): void {
    this.search();
    this.approveDebtorUploadRow.show();
  }

  public hideChildModal(): void {
    this.approveDebtorUploadRow.hide();
  }

  ngOnChanges(changes) {
    this.id = changes['id'] ? changes['id'].currentValue : '';
    this.initParams = {cookieid: this.id};
  }

  public submiting: boolean = false;

  constructor(
    public gridService: ApproveDebtorUploadRowService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {
    super(securityService, logger, visualsService, gridService, 'approveDebtorUploadRow');

    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.getValidationMessages();
      },
    });
  }
}
